import { apiFetch, apiFetchBlob } from '@/lib/api';

// Module-local helper — mirrors the pattern in leadService.ts.
function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const accountService = {
  async exportData(): Promise<void> {
    const { blob, filename } = await apiFetchBlob('/account/export');
    triggerDownload(blob, filename);
  },

  async deleteAccount(phrase: string): Promise<void> {
    await apiFetch<void>('/account/delete', {
      method: 'POST',
      body: JSON.stringify({ confirmation_phrase: phrase }),
    });
  },
};
